module.exports = __webpack_public_path__ + "img/HappyPhoto24.f7e10759.jpeg";